import { c as _c } from "react/compiler-runtime";
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import { CardHeader } from './CardHeader';
import type { CtaAnalyticsProps } from './CTA/CtaLink';
export type ProductCardRedesignCardHeaderProps = {
  ctaAnalytics: CtaAnalyticsProps;
  creditCardOffer: Offer;
};
export const OfferName = t0 => {
  const $ = _c(7);
  const {
    ctaAnalytics,
    creditCardOffer
  } = t0;
  const {
    name,
    details: t1
  } = creditCardOffer;
  const {
    applyLink,
    isActive,
    isMonetizing,
    reviewLink
  } = t1;
  const isReview = !isActive || !isMonetizing || !applyLink;
  const destinationURL = isReview ? reviewLink : applyLink;
  let t2;
  if ($[0] !== ctaAnalytics) {
    t2 = {
      ...ctaAnalytics,
      linkType: "PRODUCT_NAME"
    };
    $[0] = ctaAnalytics;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== creditCardOffer || $[3] !== destinationURL || $[4] !== name || $[5] !== t2) {
    t3 = <CardHeader analytics={t2} productName={name} link={destinationURL} offer={creditCardOffer} />;
    $[2] = creditCardOffer;
    $[3] = destinationURL;
    $[4] = name;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};